import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CarWashPackage } from "../../../types/carWash.types";

export const WashPanelItem = ({
  pkg,
  setSelectedWashID,
}: {
  pkg: CarWashPackage;
  setSelectedWashID: (id: string) => void;
}) => {
  const { t } = useTranslation();

  return (
    <div
      key={pkg._id}
      className="group flex items-center justify-between rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-5 py-4 transition-all duration-200 hover:shadow-md hover:border-primaryText dark:hover:border-primaryTextDark"
      onClick={() => setSelectedWashID(pkg._id)}
    >
      <div className="flex flex-col gap-1">
        <span className="text-xs text-gray-500 dark:text-gray-400">
          <span className="font-medium">{t("Wash ID")}</span>
          {": "}
          {pkg._id}
        </span>

        <span className="text-sm text-primaryText dark:text-primaryTextDark">
          <span className="font-medium">{t("Title")}</span>
          {": "}
          {pkg.title}
        </span>

        <span className="text-xs text-gray-500 dark:text-gray-400">
          <span className="font-medium">{t("Description")}</span>
          {": "}
          {pkg.description}
        </span>
      </div>
      <ChevronRight className="w-6 h-6 text-gray-400 opacity-0 group-hover:opacity-100 transition-all duration-200 group-hover:translate-x-1" />
    </div>
  );
};
